module.exports = __webpack_public_path__ + "media/images/players/VINCENT_KIERAN-10ab7b58ba820de139db8998ff8370e5.png";